const config = {
    build_number: '615314',
    build_timestamp: '2026-08-13T00:45:22.873Z',
    build_commit: '24787f3f4cb3a747db69dd373ec846a9c09a0188',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
